const baseUrl = "Dashboard";

export const studentDashboardUrl = () => `Dashboard/getstudentdashboard`;
export const lecturerDashboardUrl = () => `Dashboard/getlecturerdashboard`;
export const superAdminDashboardUrl = (id) =>
	`Dashboard/admin-dashboard${id ? `?sessionId=${id}` : ""}`;
export const createRatingUrl = () => `${baseUrl}/create-rating`;
